import { PhasePlaceholder } from '@/components/PhasePlaceholder';

export function ChangelogPage() {
  return (
    <div className="px-4 md:px-8 py-12">
      <PhasePlaceholder title="Changelog" phaseNote="Ships in Phase 2." />
    </div>
  );
}
